import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=1fbc8916&scoped=true"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=1fbc8916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc8916",
  null
  
)

export default component.exports